import { render, staticRenderFns } from "./nav-item.vue?vue&type=template&id=493ee2e0&scoped=true&"
import script from "./nav-item.vue?vue&type=script&lang=js&"
export * from "./nav-item.vue?vue&type=script&lang=js&"
import style0 from "./nav-item.vue?vue&type=style&index=0&id=493ee2e0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493ee2e0",
  null
  
)

export default component.exports